import request from '../utils/request';
/**
 * @description: 查询车主信息
 * @param {*} data 
 */
export function queryByPhone(data) {
  return request({
    url: '/api/weixin/queryByPhone?openId='+data.openId+'&phone='+data.phone,
    method: 'post',
    // data
  })
}
/**
 * @description: 查询客户绑定的车辆
 * @param {*} params 
 */
 export function queryByWx(params) {
    return request({
      url: '/api/weixin/queryByWx',
      method: 'get',
      params
    })
  }
